import React from "react";
import { CCol, CFormGroup, CLabel, CRow } from "@coreui/react";
import CurrencyField from "../../currencies/CurrencyField";
import { useDebitNoteFormContext } from "../context/DebitNoteFormContext";

const SectionDivider: React.FC<{ icon: string; label: string }> = ({ icon, label }) => (
  <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", marginTop: "16px" }}>
    <div style={{ width: "4px", height: "18px", background: "#006657", borderRadius: "2px", marginRight: "10px", flexShrink: 0 }} />
    <i className={`fa ${icon} mr-2`} style={{ fontSize: "0.85rem", color: "var(--theme-accent)" }}></i>
    <h6 style={{ margin: 0, fontWeight: 600, color: "var(--theme-muted)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.8px" }}>
      {label}
    </h6>
    <div style={{ flex: 1, height: "1px", background: "var(--theme-divider)", marginLeft: "10px" }} />
  </div>
);

const TotalLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <CLabel className="mb-0" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>
    {children}
  </CLabel>
);

export const DebitNoteFormTotals: React.FC = () => {
  const {
    currency,
    totalAmount,
    amount10Percent,
    amount5Percent,
    amountExempt,
    iva10Percent,
    iva5Percent,
  } = useDebitNoteFormContext();

  return (
    <>
      <SectionDivider icon="fa-calculator" label="Resumen de Totales" />
      <div
        style={{
          background: "var(--theme-highlight)",
          border: "1px solid var(--theme-highlight-border)",
          borderRadius: "8px",
          padding: "16px 20px",
          marginBottom: "16px",
        }}
      >
        {/* Total principal */}
        <CFormGroup>
          <CRow className="align-items-center">
            <CCol md={2}>
              <TotalLabel>Total:</TotalLabel>
            </CCol>
            <CCol md={3}>
              <div style={{ fontWeight: 700, fontSize: "1.1rem", color: "var(--theme-accent)" }}>
                <CurrencyField
                  placeholder="Total"
                  limit={1000000000000}
                  currency={currency}
                  value={totalAmount}
                  disabled
                />
              </div>
            </CCol>
          </CRow>
        </CFormGroup>

        {/* Bases imponibles */}
        <CFormGroup>
          <CRow className="align-items-center">
            <CCol md={2}>
              <TotalLabel>Base 10%:</TotalLabel>
            </CCol>
            <CCol md={2}>
              <CurrencyField
                placeholder="Gravada 10%"
                limit={1000000000000}
                currency={currency}
                value={amount10Percent}
                disabled
              />
            </CCol>
            <CCol md={2}>
              <TotalLabel>Base 5%:</TotalLabel>
            </CCol>
            <CCol md={2}>
              <CurrencyField
                placeholder="Gravada 5%"
                limit={1000000000000}
                currency={currency}
                value={amount5Percent}
                disabled
              />
            </CCol>
            <CCol md={2}>
              <TotalLabel>Exenta:</TotalLabel>
            </CCol>
            <CCol md={2}>
              <CurrencyField
                placeholder="Exenta"
                limit={1000000000000}
                currency={currency}
                value={amountExempt}
                disabled
              />
            </CCol>
          </CRow>
        </CFormGroup>

        {/* IVA */}
        <CFormGroup className="mb-0">
          <CRow className="align-items-center">
            <CCol md={2}>
              <TotalLabel>IVA 10%:</TotalLabel>
            </CCol>
            <CCol md={2}>
              <CurrencyField
                placeholder="IVA 10%"
                limit={1000000000000}
                currency={currency}
                value={iva10Percent}
                disabled
              />
            </CCol>
            <CCol md={2}>
              <TotalLabel>IVA 5%:</TotalLabel>
            </CCol>
            <CCol md={2}>
              <CurrencyField
                placeholder="IVA 5%"
                limit={1000000000000}
                currency={currency}
                value={iva5Percent}
                disabled
              />
            </CCol>
          </CRow>
        </CFormGroup>
      </div>
    </>
  );
};
